<template>
  <div class="question-container">
    <!-- PREVIEW MODE -->
    <div v-if="mode == 0">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
        </div>

        <div class="col-md-7">
          <template v-if="answer && answer.answerText">
            <div v-for="(imgURL, imgIndex) in getSelectedLanguageImageUrls()" :key="imgIndex" class="mb-15 mr-15">
              <img v-if="imgURL" class="participant-response__img-response mr-15" :src="imgURL" alt="image response" />
              <span v-if="showOtherOptionContent" class="mr-15">{{ question.otherOptionContentField }}</span>
            </div>
          </template>
        </div>
        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- EDIT MODE -->
    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="question.isSkippable">Optional</span>
          <span v-if="isQuestionSkipped()" class="skipped-question-box ml-15 d-inline-box pt-2">
            Skipped
          </span>
        </div>
        <div class="col-md-7" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <div class="image-edit-mode d-flex flex-wrap" v-if="question.subType === 'Single'">
            <div class="position-relative" v-for="image in getAllLanguageImages()" :key="image.id" :class="answer.isDisabled ? 'field-disabled' : ''">
              <div class="image-edit-mode__checkbox position-absolute d-inline-block" v-if="updatedAns[0] === image.id">
                <img alt="" src="static/img/participant-selected-image-checkbox.png" />
              </div>
              <img v-if="image.imageUrl && image.id != question.otherOptionId" class="image-edit-mode__image mr-15" :src="image.imageUrl" alt="image response" @click="toggleImageSelection(image.id, 'single')" />
              <span class="mr-15" v-else @click="toggleImageSelection(image.id, 'single')">{{ image.imageUrl }}</span>
            </div>
          </div>

          <!-- Multiple Selection -->
          <div class="image-edit-mode d-flex flex-wrap" v-else-if="question.subType === 'Multi'">
            <div class="position-relative" v-for="image in getAllLanguageImages()" :key="image.id" :class="answer && answer.isDisabled ? 'field-disabled' : ''">
              <div class="image-edit-mode__checkbox position-absolute d-inline-block" v-if="selectedOrNot(image.id)">
                <img alt="" src="static/img/participant-selected-image-checkbox.png" />
              </div>
              <img v-if="image.imageUrl && image.id != question.otherOptionId" class="image-edit-mode__image mr-15" :src="image.imageUrl" alt="image response" @click="toggleImageSelection(image.id, 'multi')" />
              <span class="mr-15" v-else @click="toggleImageSelection(image.id, 'multi')">{{ image.imageUrl }}</span>
            </div>
            <span class="text-danger pl-15 fw-bold" v-if="hasFieldError">This field is required.</span>
            <span class="text-warning pl-5 fw-bold " v-else-if="hasFieldWarning">This field is required.</span>
          </div>
        </div>

        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- RESPONSE MODE -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="checkForEditedStatus" data-testid="changed-status"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <template v-if="answer && answer.answer_text">
              <div class="col-md-12 d-flex pl-30">
                <img alt="" class="participant-response__img-response mr-10" :src="image.imageUrl" v-for="image in getImages(answer.question_id, answer.option_id)" :key="image.id" />
              </div>
              <div class="row">
                <div class="d-inline-block ml-25 pt-10" v-if="showScore && activityType == 'activity' && answer.score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="checkForEditedStatus" data-testid="previous-answer-display">
          <div v-if="answer && answer.edit_status == 1">
            <span class="previous-value-mark"></span>
            <div class="previous-value ml-3">PREVIOUS RESPONSE</div>
            <template v-if="answer && answer.privius_answer_text">
              <img alt="" class="participant-response__img-response mr-10" :src="image.imageUrl" v-for="image in getImages(answer.question_id, answer.privius_optionId)" :key="image.id" />
              <div class="row">
                <div class="d-inline-block ml-0 pt-10" v-if="showScore && answer.privius_score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.privius_score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
export default {
  name: "ImageChoiceResponse",
  mixins: [activityCommonMixin],
  data() {
    return {
      updatedAns: [],
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: "",
      fieldWarningText: "",
      showOtherOptionContent: false
    };
  },
  props: {
    mode: Number,
    answer: Object,
    question: Object,
    usage: Object,
    surveyData: Object,
    stepIndex: Number,
    selectedLanguageCulture: String,
    tempEditedAnswers: Object,
    activityType: String
  },
  watch: {
    hasFieldError(val) {
      this.question.hasFieldError = val;
    },
    updatedAns() {
      this.checkForFieldErrors();
      if (this.hasFieldError) {
        this.resetFields();
      } else {
        if (this.question.languageImageOptions && this.question.languageImageOptions.length) {
          const selectedOption = this.question.languageImageOptions[0].options.filter(opt => opt.id == this.updatedAns[0])[0];

          if (this.answer && selectedOption) {
            if (this.question.subType == "Single") {
              this.answer.optionId = selectedOption.id;
              this.answer.answerText = selectedOption.sequence;
            } else {
              this.answer.optionId = this.updatedAns.join();
              const multipleOptions = this.findAnsweredSequence().map(i => i.sequence);
              this.answer.answerText = multipleOptions.join();
            }
            this.answer.score = selectedOption.score;
            this.answer.computedScore = selectedOption.score;
          }
        }
      }
    }
  },
  computed: {
    checkForEditedStatus () {
      return !!(this.answer && this.answer.edit_status == 1 && this.answer.privius_answer_text);
    }
  },
  mounted() {
    if (this.answer) {
      if (this.question.subType == "Multi" && this.answer && this.answer.hasOwnProperty("optionId")) {
        const arrMultiOptions = this.answer.optionId ? this.answer.optionId.split(",") : [];
        if (arrMultiOptions.includes(this.question.otherOptionId) && this.question.otherOptionContentField) {
          this.showOtherOptionContent = true;
        }
      }
      if (this.mode == 2 && this.answer.option_id) {
        if (this.question.subType == "Single") {
          this.updatedAns[0] = this.answer.option_id;
        } else {
          this.updatedAns = this.answer.option_id.split(",");
        }
      } else if (this.answer && this.answer.hasOwnProperty("optionId")) {
        this.insertOtherOption();
        if (this.question.subType == "Single") {
          this.updatedAns[0] = this.answer.optionId;
        } else {
          this.updatedAns = this.answer.optionId.split(",");
        }
      }
    }
  },
  methods: {
    resetFields() {
      this.answer.optionId = "";
      this.answer.answerText = "";
      this.answer.score = 0;
      this.answer.computedScore = 0;
    },
    getImages(question_id, option_id) {
      const question = this.question;
      const options = option_id.split(",");
      const images = question.languageImageOptions[0].options;
      return options.map(option => {
        return images.find(image => image.id == option);
      });
    },
    findAnsweredSequence() {
      return this.updatedAns.map(item => {
        return this.question.languageImageOptions[0].options.filter(opt => opt.id == item)[0];
      });
    },
    getSelectedLanguageImageUrls() {
      if (!this.answer.languageImageUrls) {
        return null;
      }
      const languageImageUrls = this.answer.languageImageUrls.find(language => language.languageCulture === this.activityLanguageCulture);
      if (languageImageUrls) {
        return languageImageUrls.imageUrls;
      }
      const englishLanguageImageUrls = this.answer.languageImageUrls.find(language => language.languageCulture === "EN");
      if (englishLanguageImageUrls) {
        return englishLanguageImageUrls.imageUrls;
      }
      return [];
    },
    getAllLanguageImages() {
      const languageImageUrls = this.question.languageImageOptions.find(language => language.languageCulture === this.activityLanguageCulture);
      if (languageImageUrls) {
        return languageImageUrls.options;
      }
      const englishImageUrls = this.question.languageImageOptions.find(language => language.languageCulture === "EN");
      if (englishImageUrls) {
        return englishImageUrls.options;
      }
      return [];
    },
    toggleImageSelection(optionImageId, type) {
      if (optionImageId == this.question.otherOptionId && this.question.otherCommentSelectedField && this.mode == 1) {
        this.$toastr.success(this.question.otherCommentSelectedField);
      }
      if (type === "single") {
        this.$set(this.updatedAns, 0, optionImageId);
      } else {
        const selectedImageIndex = this.updatedAns.findIndex(id => id === optionImageId);
        if (selectedImageIndex === -1) {
          this.updatedAns.push(optionImageId);
        } else {
          this.updatedAns.splice(selectedImageIndex, 1);
        }
      }
      this.checkForFieldErrors();
      this.$nextTick(() => {
        this.$emit(`answerChanged`, {
          questionId: this.question.id,
          newAns: this.updatedAns
        });
      });
    },
    checkForFieldErrors() {
      this.reseterror();
      this.question.dataChecks = [];
      const dataEditChecks = this.question.dataEditChecks;
      if (dataEditChecks && dataEditChecks.length) {
        let softDataCheck = false;
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "NOT_BLANK" && (this.updatedAns == null || this.updatedAns == "")) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.question.isSkippable = true;
              softDataCheck = true;
              this.question.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: "This field is required."
              });
            }
          } else {
            if (dataEditChecks[k].type == "NOT_BLANK" && (this.updatedAns == null || this.updatedAns == "")) {
              this.hasFieldError = true;
              this.question.isSkippable = false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      } else {
        if (this.updatedAns == null || this.updatedAns == "") {
          this.hasFieldError = true;
          return false;
        }
      }

      return true;
    },
    reseterror() {
      this.hasFieldError = false;
    },
    selectedOrNot(imageId) {
      const found = this.updatedAns.findIndex(item => item == imageId);
      if (found == -1) {
        return false;
      } else {
        return true;
      }
    },
    insertOtherOption() {
      if (this.question.otherOptionId) {
        const sequence = this.question.languageImageOptions[0].options.length + 1;
        this.question.languageImageOptions[0].options.push({
          enabled: true,
          excludeScore: false,
          formattedBody: "",
          id: this.question.otherOptionId,
          imageId: this.question.otherOptionId,
          imageUrl: this.question.otherOptionContentField,
          isAdvancedScoring: false,
          previewImageUrl: this.question.otherOptionContentField,
          priority: 0,
          score: 0,
          sendNotification: false,
          sequence: sequence
        });
      }
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.participant-response__img-response {
  object-fit: cover;
  border-radius: 5px;
}

.field-disabled {
  pointer-events: none;
  opacity: 0.4;
}

.image-edit-mode {
  &__checkbox {
    /* background-color: #4c8ce4; */
    left: 5px;
    top: 5px;
    /* width: 15px; */
    /* height: 15px; */
    /* display: flex; */
    /* align-items: center; */

    /* span { */
    /* color: #ffffff; */
    /* font-size: 10px; */
    /* } */
  }

  &__image {
    width: 90px;
    height: 90px;
  }
}

.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}
.question-text {
  display: inline;
}

.previous-value-mark {
  width: 9px;
  height: 51px;
  background-color: #f5a623;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.previous-value {
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #f5a623;
  margin-bottom: 9px;
  margin-top: 3px;
}

.answers {
  font-weight: 600;
  color: #000000;
}
</style>
